// extracted by mini-css-extract-plugin
export var childrenContainer = "_cj-0";
export var virtualScrollArea = "_cj-1";